<section class="bg-light-primary py-3">
    <div class="container">
        <!-- Grid data + Map  -->
        <div class="row my-3">
            <!-- Left section -->
            <div class="col-sm-12 col-md-12">
                <h1 class="fw-bold my-3 fs-2">National Performance</h1>
                <p class="my-3">
                    Summary of key national-level demographics and municipal (urban) indicators
                </p>
                <!-- Grid -->
                @if (nationalDashboardService.isLoading()) {
                <app-pre-loader></app-pre-loader>
                <app-pre-loader></app-pre-loader>
                } @else {
                <!-- @if(this.selectedLedgerYear()) { -->
                <app-grid-view [gridData]="nationalDashboardService.exploreData().gridDetails" [columns]="2"></app-grid-view>
                <!-- } -->
                }
            </div>
        </div>

        <!-- Money Cards -->
        <!-- @if (this.isLoading2) { -->
        @if (nationalDashboardService.isLoading()) {
        <app-pre-loader></app-pre-loader>
        } @else {
        @if(this.selectedLedgerYear()) {
        <app-info-cards [items]="moneyInfo()"></app-info-cards>
        }
        }

        <!-- Last modified date -->
        <p class="text-secondary text-end mt-3 mb-0 d-flex justify-content-end align-items-center gap-1 flex-wrap"
            style="font-size: 0.75rem">
            Last updated on:
            {{ nationalDashboardService.exploreData().lastModifiedAt | date : "mediumDate" }}; Source:
            financial statements for the year <select class="form-select form-select-sm w-auto d-inline-block"
                [value]="selectedLedgerYear()" (change)="onMoneyInfoYearChange($event)" id="national_years">
                @for (year of ledgerYears(); track $index) {
                <option [value]="year" [selected]="year === selectedLedgerYear()">
                    {{ year }}
                </option>
                }
            </select>
        </p>
    </div>
</section>

<section class="container matTabGroup">
    <!-- <div class="alert alert-info text-center mt-5" role="alert">
        <i class="bi bi-bell"></i>
        NEW ON CITY FINANCE: 10,000+ budget documents of 2,000 cities(FY 2020-2024) are now available for
        download. <a [href]="`${v1Url}/resources-dashboard/data-sets/income_statement`">Click here to access files.</a>
    </div> -->
    <h3 class="fw-bold p-2 my-4 text-center">Dashboard</h3>
    @if(dashboardTabs() && dashboardTabs().length !== 0) {
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [(selectedIndex)]="selectedIndex">
        @for (tab of dashboardTabs(); track $index) {
        <mat-tab [label]="tab.name">
            @if(selectedIndex === $index) {
            @if(tab.name === 'Data Availability' && ledgerYears().length) {
            <app-data-availability [ledgerYears]="ledgerYears()"></app-data-availability>
            } @else if (tab.name === 'Resources') {
            <app-resources></app-resources>
            } @else {
            <app-financial-indicators [dashboardTabData]="tab" [ledgerYears]="ledgerYears()"
                (navigateTab)="selectedIndex = 0"></app-financial-indicators>
            }
            }
            <!-- {{tab | json}} -->
        </mat-tab>
        }
    </mat-tab-group>
    }
</section>